import React from "react";
import "./navbar.css";
import Logo from "../assets/enteeon_logo.png";
import { Link } from "react-router-dom";
// Analytics disabled

const Navbar = () => {
  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-white">
      <div className="container">
        {/* Logo with Home Link */}
        <Link to="/" className="navbar-brand">
          <img src={Logo} className="img-fluid" alt="Enteeon Logo" />
        </Link>

        {/* Mobile Toggle Button */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Navigation Links */}
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto">
            <li className="nav-item">
              <Link to="/" className="nav-link">Home</Link>
            </li>
            <li className="nav-item">
              <Link to="/problemimpact" className="nav-link">The Problem & Impact</Link>
            </li>
            <li className="nav-item">
              <Link to="/products" className="nav-link">Products</Link>
            </li>
            <li className="nav-item">
              <Link to="/sustainability" className="nav-link">Sustainability & Science</Link>
            </li>
            <li className="nav-item">
              <Link to="/blog" className="nav-link">Blog</Link>
            </li>
            <li className="nav-item">
              <Link to="/contact" className="nav-link">Contact</Link>
            </li>
          </ul>

          {/* Reach Us Button */}
          <Link to="/contact" className="btn reach-us">Reach us!</Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
